var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 0.666626H3.83333C2.9496 0.667685 2.10237 1.01921 1.47748 1.64411C0.852588 2.269 0.501059 3.11623 0.5 3.99996L0.5 12C0.501059 12.8837 0.852588 13.7309 1.47748 14.3558C2.10237 14.9807 2.9496 15.3322 3.83333 15.3333H13.1667C14.0504 15.3322 14.8976 14.9807 15.5225 14.3558C16.1474 13.7309 16.4989 12.8837 16.5 12V3.99996C16.4989 3.11623 16.1474 2.269 15.5225 1.64411C14.8976 1.01921 14.0504 0.667685 13.1667 0.666626ZM3.83333 1.99996H13.1667C13.5659 2.00074 13.9557 2.12097 14.286 2.34516C14.6163 2.56935 14.8719 2.88726 15.02 3.25796L9.91467 8.36396C9.53895 8.73817 9.03028 8.94827 8.5 8.94827C7.96972 8.94827 7.46105 8.73817 7.08533 8.36396L1.98 3.25796C2.1281 2.88726 2.38374 2.56935 2.71403 2.34516C3.04432 2.12097 3.43414 2.00074 3.83333 1.99996ZM13.1667 14H3.83333C3.3029 14 2.79419 13.7892 2.41912 13.4142C2.04405 13.0391 1.83333 12.5304 1.83333 12V4.99996L6.14267 9.30663C6.76842 9.9308 7.61617 10.2813 8.5 10.2813C9.38383 10.2813 10.2316 9.9308 10.8573 9.30663L15.1667 4.99996V12C15.1667 12.5304 14.956 13.0391 14.5809 13.4142C14.2058 13.7892 13.6971 14 13.1667 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.46122b11ea27bc00ac2dcceacc0aa67e.svg";
export { ForwardRef as ReactComponent };